import React from "react";
import { Route, withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import SelectCity from "../MainCard/SelectCity/SelectCity";
import Map from "../Map/Map";
import TutorialCard from "../MainCard/TutorialCard/TutorialCard";
import MainCard from "../MainCard/MainCard";
import Loader from "./Loader/Loader";
import "./App.css";

const App = props => (
  <div className="app">
    <main>
      <Route exact path="/" component={SelectCity} />
      <Route exact path="/:city" component={TutorialCard} />
      <Route exact path="/:city/:action" component={MainCard} />
    </main>
    <Map />
    {props.isLoading && <Loader />}
  </div>
);

App.propTypes = { isLoading: PropTypes.bool.isRequired };

const mapStateToProps = state => ({
  isLoading: state.search.isLoading
});

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));



// WEBPACK FOOTER //
// ./src/containers/App/App.jsx